module.exports = __webpack_public_path__ + "static/media/11-7.727406ae.mp3";